import { __read } from "tslib";
export var COST_CENTER_FIELD = 'defaultDepartment.form.costCenter';
export var LEGAL_ENTITY_FIELD = 'defaultDepartment.form.legalEntity';
export var availableBaseFields = [
    ['name', function () { return i18n.get('姓名'); }],
    ['nickName', function () { return i18n.get('别名'); }],
    ['email', function () { return i18n.get('邮箱'); }],
    ['departments', function () { return i18n.get('部门'); }],
    ['cellphone', function () { return i18n.get('手机'); }],
    ['code', function () { return i18n.get('工号'); }],
    ['note', function () { return i18n.get('备注'); }],
    [COST_CENTER_FIELD, function () { return i18n.get('成本中心'); }],
    [LEGAL_ENTITY_FIELD, function () { return i18n.get('法人实体'); }],
    ['appName', function () { return i18n.get('应用授权'); }],
];
export var allBaseFields = availableBaseFields.map(function (_a) {
    var _b = __read(_a, 1), key = _b[0];
    return key;
});
